import Breadcrumb from "Components/organisms/breadcrumb"
import LoadingState from "Components/organisms/loading-state"
import { Container } from "reactstrap"

interface GraphTemplateProps {
    title: string
    breadcrumbItem: string
    actions?: React.ReactNode
    tableActions?: React.ReactNode
    filters?: React.ReactNode
    isLoading: boolean
    children: React.ReactNode
    modal?: React.ReactNode
}

const GraphTemplate = ({ title, breadcrumbItem, actions, tableActions, filters, isLoading, children, modal }: GraphTemplateProps) => (
    <div className="page-content">
        <Container fluid style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <Breadcrumb title={title} breadcrumbItem={breadcrumbItem} actions={actions} />
            {filters && <div className="section-container">{filters}</div>}
            {isLoading ? (
                <div className="section-container">
                    <LoadingState title="Loading Data" subtitle="Fetching information…" />
                </div>
            ) : (
                <>
                    {tableActions && (
                        <div className="d-print-none" style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: '10px',
                            justifyContent: 'flex-end',
                        }}>
                            {tableActions}
                        </div>
                    )}
                    {/* Each child is its own card (section-container) */}
                    {children}
                </>
            )}
            {modal}
        </Container>
    </div>
)

export default GraphTemplate
